/** @type {DiscordUserData} */
export let userData = {
  id: "",
  username: "",
  avatar: "",
  displayname: "",
  level: 0,
  xp: 0,
  totalMiles: 0,
};

/**
 * Set user data globally.
 * @param {DiscordUserData} data
 */
export function setUserData(data) {
  userData = data;
}

/**
 * Track the page view.
 */
export function trackPage() {
  // @ts-expect-error
  gtag("config", "G-H5RKXXPSJV", {
    page_location: window.location.href,
    page_path: window.location.pathname,
  });
}

/**
 * Get the name of the click event based on device type.
 * @returns {string}
 */
export function clickEventName() {
  return window.ontouchstart ? "touchstart" : "click";
}

/**
 * Check if we are running in development mode.
 * @returns {boolean}
 */
export function isDevMode() {
  return (
    typeof window !== "undefined" && window.location.hostname === "localhost"
  );
}

/**
 * Check if we are on a mobile device.
 * @returns {boolean}
 */
export function isMobileDevice() {
  const userAgentCheck =
    /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(
      navigator.userAgent
    );
  const screenCheck = window.matchMedia("(max-width: 768px)").matches;
  return userAgentCheck || screenCheck;
}

/**
 * Check if the device is an iOS device.
 * @returns {boolean}
 */
export function isIOSDevice() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

/**
 * Check if the app is running as a standalone app (PWA).
 * @returns {boolean}
 */
export function isStandaloneApp() {
  return (
    typeof window !== "undefined" &&
    window.matchMedia("(display-mode: standalone)").matches
  );
}

/**
 * Navigate to a path, using the app router if available.
 * @param {string} path
 */
export function navigateTo(path) {
  /** @type {import('../approuter').AppRouter} */
  const router = document.querySelector("app-router");
  if (router) {
    router.router.render(path);
  } else {
    window.location.href = path;
  }
}

/**
 * Set the title of the page.
 * @param {string} title
 */
export function setTitle(title) {
  document.title = `${title ? `${title} | ` : ""}Plane Pals, online multiplayer for XPlane`;
}
